import { Code, Stack, Table, Title } from "@mantine/core";
import { useQuery } from "@tanstack/react-query";

import { api, call } from "../api/client";
import { ErrorAlert, Loading, formatTs } from "../components/common";

export function AuditPage() {
  const logs = useQuery({
    queryKey: ["audit"],
    queryFn: () => call(api.GET("/api/v1/audit-logs", { params: { query: { limit: 200 } } })),
  });
  if (logs.isLoading) return <Loading />;
  if (logs.error) return <ErrorAlert error={logs.error} />;
  return (
    <Stack>
      <Title order={2}>Audit log</Title>
      <Table.ScrollContainer minWidth={800}>
        <Table striped fz="sm">
          <Table.Thead><Table.Tr><Table.Th>Time</Table.Th><Table.Th>Action</Table.Th><Table.Th>Actor</Table.Th><Table.Th>Entity</Table.Th><Table.Th>Details</Table.Th><Table.Th>IP</Table.Th></Table.Tr></Table.Thead>
          <Table.Tbody>
            {logs.data!.map((l) => (
              <Table.Tr key={l.id}>
                <Table.Td>{formatTs(l.created_at)}</Table.Td>
                <Table.Td>{l.action}</Table.Td>
                <Table.Td>{l.actor_type}</Table.Td>
                <Table.Td>{l.entity_type ?? "—"}</Table.Td>
                <Table.Td><Code>{l.details ? JSON.stringify(l.details) : ""}</Code></Table.Td>
                <Table.Td>{l.ip ?? "—"}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Stack>
  );
}
